import { TipoCalculoEnum } from "./enums";

export class TarifaModel {

    id:Number;
    nombre:String;
    fechaInicio:Date;
    fechaFin:Date;
    tipoCalculo: TipoCalculoEnum;
    // importeFijo:number;
    // porcentaje:number;
    // max:number;
    // min:number;
    activo:boolean;
    createdBy:String;
    createdDate:Date;
    updatedBy:String;
    updatedDate:Date;

    public constructor(){
        this.id = null;
        this.nombre = null;
        this.fechaInicio = null;
        this.fechaFin = null;
        this.tipoCalculo = null;
        // this.importeFijo = null;
        // this.porcentaje = null;
        // this.max = null;
        // this.min = null;
        this.activo = null;
        this.createdBy = null;
        this.createdDate = null;
        this.updatedBy = null;
        this.updatedDate = null;    
    }
}